import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { layoutTexts } from './texts';

export function NotFound() {
  return (
    <div className="flex flex-col items-start gap-4">
      <h1 className="text-2xl font-semibold">{layoutTexts.notFound.title}</h1>
      <p className="text-muted-foreground">{layoutTexts.notFound.description}</p>
      <Button asChild variant="outline">
        <Link to="/">{layoutTexts.notFound.backHome}</Link>
      </Button>
    </div>
  );
}
